import PreviewIcon from "@mui/icons-material/Preview";
import DownloadIcon from "@mui/icons-material/Download";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const getReportIndexColumns = (
  handleView,
  handleDownload,
  handleViewRequest
) => [
//   {
//     accessorKey: "ReportID",
//     header: "ID",
//     size: 100,
//   },
  {
    accessorKey: "ReportName",
    header: "Report Name",
    size: 350,
  },
  {
    accessorKey: "ReportDescription",
    header: "Report Description",
    size: 350,
  },
  {
    accessorKey: "UserName",
    header: "Created By",
    size: 350,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    enableColumnActions: false,
    enableSorting: false,
    Cell: ({row}) => (
      <div className="ActionBtns">
        <OverlayTrigger placement="bottom" overlay={<Tooltip>View</Tooltip>}>
          <button className="DataAccessEdit" onClick={() => handleView(row.original)}>
            <PreviewIcon className="ActionsIcon" />
          </button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>Download</Tooltip>}
        >
          <button className="DataAccessEdit" onClick={() => handleDownload(row.original)}>
            <DownloadIcon className="ActionsIcon" />
          </button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>View Request</Tooltip>}
        >
          <button
            className="DataAccessEdit"
            onClick={() => handleViewRequest(row.original)}
          >
            <WysiwygIcon className="ActionsIcon" />
          </button>
        </OverlayTrigger>
      </div>
    ),
  },
];
